import styled from 'styled-components';
import { Divider } from 'ui/divider';
import { spacing } from 'ui/theme';

export const MovementDivider = styled(Divider)`
  margin: ${spacing.threeQuarter} 0;
  width: 100%;
`;
